import { css } from '@emotion/react';

export default ({ absolute, objectStyles }) => [
  css`
    display: flex;
    height: inherit;
    margin: -16px;
    position: relative;
  `,
  absolute &&
    css`
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    `,
  objectStyles,
];
